






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Restaurant, RestaurantObject } from '../Restaurant';
import RestaurantInfo from './RestaurantInfo.vue';
//@ts-ignore
import { Carousel, Slide } from 'vue-carousel';

@Component<BottomPopup>({
    components: {
        RestaurantInfo,
        Carousel,
        Slide,
    },
    watch: {
        selectedRestaurants(): void {
            this.updateRestaurants();
        }
    }
})
export default class BottomPopup extends Vue {

    //@ts-ignore
    @Prop() selectedRestaurants: RestaurantObject[];
    private restaurants: Restaurant[] = [];

    /**
     * Vue mounted hook.
     */
    public mounted(): void {
        this.updateRestaurants();
    }

    /**
     * Update active restaurant info to store.
     */
    public updateRestaurants(): void {
        this.restaurants = this.selectedRestaurants.map(restaurant => new Restaurant(
            restaurant.title,
            restaurant.address,
            restaurant.location,
            restaurant.website,
            restaurant.type,
            restaurant.lunchUrl
        ));
        if (this.restaurants.length) {
            this.$store.commit("activeRestaurant", this.restaurants[0].toObject());
        }
    }

    /**
     * Handle page change event.
     * 
     * @param pageNumber number of the page.
     */
    public handlePageChange(pageNumber: number): void {
        if (this.restaurants.length > pageNumber) {
            this.$store.commit("activeRestaurant", this.restaurants[pageNumber].toObject());
        }
    }

    /**
     * Handle bottom popup close.
     */
    public handleClose(): void {
        this.$store.commit("showBottomPopup", false);
        // Add setTimeout so closing animation will run before clearing panel contents.
        setTimeout(() => {
            this.restaurants = [];
            this.$store.commit("selectedRestaurants", []);
            this.$store.commit("activeRestaurant", null);
        }, 500)
    }
}
